/* Maison Minéral additions for Judge.me:
   1) emoji shortcodes in reviews (e.g. :heart:) shown as real emoji
   2) 'Post review as anonymous' ticked by default in the write-a-review form (the customer can untick it)
   No MutationObserver (avoids render loops): light checks on load, on clicks and briefly on an interval. */
(function () {
  var M = {
    'heart':'❤️','hearts':'♥️','heart_eyes':'😍','two_hearts':'💕','sparkling_heart':'💖','heartpulse':'💗','heartbeat':'💓','revolving_hearts':'💞','gift_heart':'💝','cupid':'💘',
    'blue_heart':'💙','green_heart':'💚','yellow_heart':'💛','purple_heart':'💜','black_heart':'🖤','white_heart':'🤍','brown_heart':'🤎','orange_heart':'🧡','pink_heart':'🩷','light_blue_heart':'🩵','grey_heart':'🩶',
    'hands_heart':'🫶','heart_hands':'🫶','smiling_face_with_3_hearts':'🥰','smiling_face_with_hearts':'🥰','kissing_heart':'😘',
    'moon':'🌙','crescent_moon':'🌙','full_moon':'🌕','new_moon':'🌑','star':'⭐','star2':'🌟','stars':'🌠','dizzy':'💫','sparkles':'✨','gem':'💎','ring':'💍','crystal_ball':'🔮','rainbow':'🌈','sunny':'☀️','sun_with_face':'🌞','fire':'🔥','100':'💯',
    'blush':'😊','relaxed':'☺️','smile':'😄','smiley':'😃','grinning':'😀','grin':'😁','slightly_smiling':'🙂','slightly_smiling_face':'🙂','innocent':'😇','wink':'😉','joy':'😂','star_struck':'🤩','star-struck':'🤩','grinning_face_with_star_eyes':'🤩','hugging_face':'🤗','hugs':'🤗','pleading_face':'🥺','smiling_face_with_tear':'🥲','cry':'😢','sob':'😭','open_mouth':'😮','astonished':'😲','exploding_head':'🤯','sunglasses':'😎','yum':'😋',
    'pray':'🙏','ok_hand':'👌','+1':'👍','thumbsup':'👍','clap':'👏','raised_hands':'🙌','muscle':'💪','wave':'👋','v':'✌️','point_up':'☝️',
    'tada':'🎉','gift':'🎁','rose':'🌹','cherry_blossom':'🌸','tulip':'🌷','sunflower':'🌻','hibiscus':'🌺','blossom':'🌼','bouquet':'💐','butterfly':'🦋','snake':'🐍','leaves':'🍃','herb':'🌿','ocean':'🌊','white_check_mark':'✅','heavy_check_mark':'✔️','kiss':'💋','crown':'👑','nail_care':'💅','woman':'👩','raised_hand':'✋',
    'skin-tone-2':'🏻','skin-tone-3':'🏼','skin-tone-4':'🏽','skin-tone-5':'🏾','skin-tone-6':'🏿'
  };
  var SEL = '.jdgm-widget, .jdgm-carousel-wrapper, .jdgm-all-reviews-widget';
  function conv(t) {
    return t.replace(/:([a-z0-9_+-]{1,40}):/gi, function (m, k) { var e = M[k.toLowerCase()]; return e ? e : m; });
  }
  function emoji() {
    var roots = document.querySelectorAll(SEL);
    for (var r = 0; r < roots.length; r++) {
      var w = document.createTreeWalker(roots[r], NodeFilter.SHOW_TEXT, null);
      var nodes = [], n;
      while ((n = w.nextNode())) { if (n.nodeValue && n.nodeValue.indexOf(':') > -1) nodes.push(n); }
      for (var i = 0; i < nodes.length; i++) {
        var v = nodes[i].nodeValue, o = conv(v);
        if (o !== v) nodes[i].nodeValue = o;
      }
    }
  }
  function anonymous() {
    var boxes = document.querySelectorAll('.jdgm-write-review-modal .jdgm-write-review-modal__checkbox-input');
    for (var i = 0; i < boxes.length; i++) {
      var b = boxes[i], lbl = b.closest('label');
      if (!lbl || !/anonym/i.test(lbl.textContent)) continue;
      if (b.getAttribute('data-mm-default') === '1') continue;
      b.setAttribute('data-mm-default', '1');
      if (!b.checked) b.click();
    }
  }
  function start() {
    emoji();
    var count = 0;
    var iv = setInterval(function () { emoji(); if (++count > 15) clearInterval(iv); }, 1000);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      if (t.closest(SEL)) { setTimeout(emoji, 400); setTimeout(emoji, 1200); }
      if (t.closest('.jdgm-write-review-modal') || t.closest(SEL)) { setTimeout(anonymous, 350); setTimeout(anonymous, 1000); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
